import { render, staticRenderFns } from "./appealReviewModal.vue?vue&type=template&id=1c5a0ba7&scoped=true"
import script from "./appealReviewModal.vue?vue&type=script&lang=js"
export * from "./appealReviewModal.vue?vue&type=script&lang=js"
import style0 from "./appealReviewModal.vue?vue&type=style&index=0&id=1c5a0ba7&prod&lang=scss&scoped=true"
import style1 from "./appealReviewModal.vue?vue&type=style&index=1&id=1c5a0ba7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c5a0ba7",
  null
  
)

export default component.exports